export default {
  default: () => import("/home/timo/community-management-system/@app/frontend/layouts/default.vue").then(m => m.default || m),
  page: () => import("/home/timo/community-management-system/@app/frontend/layouts/page.vue").then(m => m.default || m)
}